(function(){
  var d=document;
  window.epxOK=true;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(f){if(d.readyState!=='loading'){f();}else{d.addEventListener('DOMContentLoaded',f);}}
  function count(el){
    var to=parseInt(el.getAttribute('data-to'),10)||0;
    if(reduce){el.textContent=to;return;}
    var t0=null,dur=1200;
    function step(t){
      if(!t0){t0=t;}
      var p=Math.min((t-t0)/dur,1);
      var e=1-Math.pow(1-p,3);
      el.textContent=Math.round(to*e);
      if(p<1){requestAnimationFrame(step);}
    }
    requestAnimationFrame(step);
  }
  ready(function(){
    var rv=d.querySelectorAll('.epx-rv');
    if('IntersectionObserver' in window&&!reduce){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting){
            e.target.classList.add('in');
            var ns=e.target.querySelectorAll('.epx-n');
            for(var i=0;i<ns.length;i++){count(ns[i]);}
            io.unobserve(e.target);
          }
        });
      },{threshold:.12});
      rv.forEach(function(el){io.observe(el);});
    }else{
      rv.forEach(function(el){el.classList.add('in');});
      var all=d.querySelectorAll('.epx-n');
      for(var j=0;j<all.length;j++){count(all[j]);}
    }
    var rot=d.querySelector('.epx-rot');
    if(rot&&!reduce){
      var words=(rot.getAttribute('data-w')||'').split(';');
      var span=rot.querySelector('span');
      var k=0;
      if(words.length>1&&span){
        setInterval(function(){
          span.classList.add('out');
          setTimeout(function(){
            k=(k+1)%words.length;
            span.textContent=words[k];
            span.classList.remove('out');
          },350);
        },2600);
      }
    }
    var tabs=d.querySelectorAll('.epx-tab');
    function selectTab(tb){
      for(var i=0;i<tabs.length;i++){
        var on=tabs[i]===tb;
        tabs[i].setAttribute('aria-selected',on?'true':'false');
        var pn=d.getElementById(tabs[i].getAttribute('aria-controls'));
        if(pn){if(on){pn.classList.add('on');}else{pn.classList.remove('on');}}
      }
    }
    tabs.forEach(function(tb,idx){
      tb.addEventListener('click',function(){selectTab(tb);});
      tb.addEventListener('keydown',function(ev){
        if(ev.key==='ArrowRight'||ev.key==='ArrowLeft'){
          var nx=tabs[(idx+(ev.key==='ArrowRight'?1:tabs.length-1))%tabs.length];
          nx.focus();selectTab(nx);
        }
      });
    });
    var chs=d.querySelectorAll('.epx-chap button');
    var out=d.querySelector('.epx-chap__out');
    chs.forEach(function(b){
      b.addEventListener('click',function(){
        chs.forEach(function(x){x.setAttribute('aria-pressed','false');});
        b.setAttribute('aria-pressed','true');
        if(out){
          out.classList.add('sw');
          setTimeout(function(){out.textContent=b.getAttribute('data-d');out.classList.remove('sw');},180);
        }
      });
    });
    if('matchMedia' in window&&window.matchMedia('(hover: hover)').matches&&!reduce){
      d.querySelectorAll('.epx-card').forEach(function(c){
        c.addEventListener('pointermove',function(ev){
          var r=c.getBoundingClientRect();
          var x=(ev.clientX-r.left)/r.width-.5;
          var y=(ev.clientY-r.top)/r.height-.5;
          c.style.transform='perspective(900px) rotateY('+(x*6)+'deg) rotateX('+(-y*6)+'deg) translateY(-4px)';
        });
        c.addEventListener('pointerleave',function(){c.style.transform='';});
      });
    }
    var hero=d.querySelector('.epx-hero');
    var st=d.querySelector('.epx-sticky');
    if(hero&&st&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        if(es[0].isIntersecting){st.classList.remove('on');}else{st.classList.add('on');}
      }).observe(hero);
    }
  });
})();